import MenuIcon from "@mui/icons-material/Menu";
import { Drawer, Tab, Tabs } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useRouter } from "next/router";
import React from "react";
import { NavItem } from "~/routes";

const useStyles = makeStyles({
  drawerContainer: {},
  iconButtonContainer: {
    marginLeft: "auto",
    color: "black",
    paddingLeft: 0,
  },
  iconButton: {
    display: "flex",
    flexDirection: "column",
    "& svg": {
      fontSize: "34px",
    },
  },

  indicator: {
    top: "0px",
  },
});

export default function MobileNav({
  networkNav,
}: {
  networkNav: NavItem[];
}): React.ReactElement {
  // const [openDrawer, setOpenDrawer] = useState(false);
  const router = useRouter();

  const classes = useStyles();
  return (
    <>
      <Drawer anchor="bottom" open={true} variant="persistent">
        <Tabs
          variant="fullWidth"
          sx={{
            mb: 2,
            ".MuiTab-labelIcon": {
              textTransform: "none",
              whiteSpace: "nowrap",
              color: "#333",
              "& .MuiButtonBase": {},
              fontSize: 8,
              "& svg": {
                fontSize: "30px",
              },
            },
          }}
          classes={{
            indicator: classes.indicator,
          }}
          allowScrollButtonsMobile
          value={router.asPath}
        >
          {networkNav.map((navItem) => (
            <Tab
              value={navItem.url}
              sx={{ minWidth: 50 }}
              onClick={() => {
                navItem.onClick
                  ? navItem.onClick()
                  : navItem.url && router.push(navItem.url);
              }}
              icon={
                navItem.icon ? (
                  React.createElement(navItem.icon)
                ) : (
                  <>
                    <MenuIcon />
                  </>
                )
              }
              key={navItem.label}
              label={navItem.label}
            />
          ))}
        </Tabs>
        {/* <Grid */}
        {/*   sx={{ py: 2 }} */}
        {/*   justifyContent="space-evenly" */}
        {/*   container */}
        {/*   spacing={0} */}
        {/* > */}
        {/* {networkNav.map(({ onClick, url, label, icon }) => ( */}
        {/*   <Grid xs={2} item key={url}> */}
        {/*     <IconButton */}
        {/*       classes={{ root: classes.iconButton }} */}
        {/*       onClick={() => { */}
        {/*         onClick ? onClick() : url && router.push(url); */}
        {/*         // setOpenDrawer(false); */}
        {/*       }} */}
        {/*       color="primary" */}
        {/*       aria-label={label} */}
        {/*       component="label" */}
        {/*     > */}
        {/*       {icon ? ( */}
        {/*         React.createElement(icon) */}
        {/*       ) : ( */}
        {/*         <> */}
        {/*           <MenuIcon /> */}
        {/*         </> */}
        {/*       )} */}
        {/*       <div */}
        {/*         style={{ */}
        {/*           fontSize: 10, */}
        {/*           overflow: "clip", */}
        {/*           whiteSpace: "nowrap", */}
        {/*           textOverflow: "ellipsis", */}
        {/*         }} */}
        {/*       > */}
        {/*         {label} */}
        {/*       </div> */}
        {/*     </IconButton> */}
        {/*   </Grid> */}
        {/* ))} */}
        {/* </Grid> */}
      </Drawer>

      {/*
      <Drawer
        anchor="left"
        classes={{ paper: classes.drawerContainer }}
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
      >
        <List>
          {networkNav.map(({ onClick, url, label }) => (
            <ListItem
              key={url}
              divider
              button
              onClick={() => {
                onClick ? onClick() : url && router.push(url);
                setOpenDrawer(false);
              }}
            >
              <ListItemIcon>
                <ListItemText>{label}</ListItemText>
              </ListItemIcon>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <IconButton
        className={classes.iconButtonContainer}
        onClick={() => setOpenDrawer(!openDrawer)}
        disableRipple
        size="large"
      >
        <MenuIcon className={classes.menuIconToggle} />
      </IconButton>
    */}
    </>
  );
}
